export default "__VITE_ASSET__Ecn1BPjf__"